import React, {Component} from "react";

class ReadOnlyField extends Component {


    render() {

        const {id,title,placeholder,value} = this.props;

        return (
            <div key={id} className={"inputFieldWrapper textField"}>
                <label htmlFor={id}>
                    {title}
                </label>
                <input
                    type="text"
                    name={id}
                    id={id}
                    placeholder={placeholder}
                    value={value || ''}
                    disabled={true}
                />
            </div>
        )
    }
}

export default ReadOnlyField;


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/Form_Elements/ReadOnlyField.js